import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { EmployeeDTO } from '@/hooks/useEmployee';
import { useDeleteEmployee } from '@/hooks/useEmployee';
import LoadingCircle from '@/components/LoadingCircle';
import { Eraser } from 'lucide-react';

const Delete = ({
  employee,
  setPage,
}: {
  employee: EmployeeDTO;
  setPage: () => void;
}) => {
  const { mutateAsync: deleteEmployee, isPending } = useDeleteEmployee();
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant="destructive"
          className="bg-red-500 hover:bg-red-600 border-red-600 transition-colors"
        >
          {isPending ? (
            <LoadingCircle />
          ) : (
            <>
              <Eraser className="w-4 h-4" />
              Xóa
            </>
          )}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="luxury-dialog">
        <AlertDialogDescription className="sr-only">
          Xác nhận xóa
        </AlertDialogDescription>
        <AlertDialogHeader className="luxury-header">
          <AlertDialogTitle className="luxury-title">
            Xác nhận xóa
          </AlertDialogTitle>
        </AlertDialogHeader>

        <div className="space-y-6">
          <div className="luxury-card">
            <p className="text-center text-lg">
              Bạn có chắc chắn muốn xóa nhân viên{' '}
              <span className="font-semibold text-luxury-900">
                {employee.username}
              </span>
              ?
            </p>
            <p className="text-center text-sm text-luxury-700 mt-2">
              Điều này sẽ xóa nhân viên này và không thể khôi phục lại.
            </p>
          </div>
        </div>

        <AlertDialogFooter className="mt-6 space-x-4">
          <AlertDialogCancel className="w-[120px] luxury-button-outline">
            Hủy
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={async () => {
              await deleteEmployee(employee.id);
              setPage();
            }}
            className="w-[120px] bg-red-500 hover:bg-red-600 text-white transition-colors"
            disabled={isPending}
          >
            {isPending ? <LoadingCircle /> : 'Xóa'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default Delete;
